const EMPTY_LENGTH = 0;

const isEmptyUtil = (value: unknown[] | string | number | null | undefined): boolean => {
  if (typeof value === 'number') {
    return !isNaN(value) && value <= EMPTY_LENGTH;
  }

  return !value || value.length <= EMPTY_LENGTH;
};

export default isEmptyUtil;
